import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button} from "antd";
import {useWindowSize} from "../useWindowSize";
import Modal from "react-modal";
import "./modal.css";

import {Store} from "pullstate";
import {AppStore} from "../../useAppPullState";
import {useMemberInputChange} from "../hooks/useMemberInputChange";
import {useAddBookingSubmit} from "../hooks/useAddBookingSubmit";


export const AddBookingStore = new Store({
    firstName: "",
    lastName: "",
    memberId: "",
    unknown: "",
    phone: "",
    isPaid: false,
    member: null,
    error: null,
    book: [],
});

const update = (key) => (value) => {
    AddBookingStore.update(s => {
        s[key] = value;
    });
}

export const setFirstName = update("firstName");
export const setLastName = update("lastName");
export const setMemberId = update("memberId");
export const setMember = (value) => {
    update("member")(value);
    if(value === null) {
        resetForm(false)
    }
}
export const setUnknown = update("unknown");
export const setPhone = update("phone")
export const setIsPaid = update("isPaid");
export const setBook = update("book");
export const setError = update("error");

export const resetForm = (clearMemberId = true) => {
    setFirstName("");
    setIsPaid(false);
    setLastName("");
    setPhone("");
    if(clearMemberId){
        setMemberId("");
    }

    setUnknown("");
};


const BookingViewStore = new Store({})

export default ({
                    course,
                    data,
                    handleCloseModal,
                    showModal,
                }) => {
    const {
        firstName,
        lastName,
        memberId,
        unknown,
        phone,
        isPaid,
        member,
        error,
    } = AddBookingStore.useState();


    const {loading, bookings} = AppStore.useState(s => ({
        loading: s.loading,
        bookings: s.bookings
    }));

    const dispatch = useDispatch();
    // const loading = useSelector(state => state.global.loader);


    useEffect(() => {
        if (member !== null && member !== undefined) {
            setFirstName(member.firstName || "");
            setLastName(member.LastName || "");
            setPhone(member.Phone || "");
            setIsPaid(member.Paid == "Paid" ? true : false);
        }
    }, [member]);
    const onSubmit = useAddBookingSubmit(data, course)
    const loader = useSelector(state => state.global.loader);
    const onInputUserChange = useMemberInputChange()
    const [width, height] = useWindowSize();
    return (
        <Modal
            isOpen={showModal}
            contentLabel='Example Modal'
            className='Modal'
            overlayClassName='Overlay'
            id='ngdialog12'
            style={{}}
            ariaHideApp={false}
        >
            <div className='container'>
                <div className='row'>
                    {member != null && width > 800 && (
                        <div className='col-6' style={{color: "green", textAlign: "left"}}>
                            Maksanut jäsen
                        </div>
                    )}
                    <div
                        className='col-6 close-ico'
                        style={{color: "red", textAlign: "right"}}
                        onClick={() => {
                            setMember(null);
                            handleCloseModal();
                        }}
                    >
                        <span> x </span>
                    </div>
                </div>
                <div className='row' style={{color: "black", textAlign: "center", fontWeight: 600}}>
                    <span className='col-form-label'>Lisaa varaustiedot</span>
                </div>
                <div className='row' style={{color: "black", marginBottom: 8, paddingBottom: 4}}>
                    <div className='col-sm-6 col-lg-5 col-md-5'>{course?.data?.courseName}</div>
                    <div className='col-sm-6 col-lg-5 col-md-5'>{data?.date}</div>
                    <div className='col-sm-4 col-lg-2 col-md-2'>
                        <input
                            className='form-check-input'
                            type='checkbox'
                            checked={isPaid}
                            id='flexCheckChecked'
                            onChange={e => setIsPaid(e.currentTarget.checked)}
                        />
                    </div>
                </div>
                <form>
                    <div className='row' style={{color: "black", paddingTop: 8}}>
                        <div className='col-sm-6'>
                            <input
                                type='text'
                                className='form-control'
                                placeholder='Sukunimi'
                                value={firstName}
                                onChange={e => setFirstName(e.currentTarget?.value || "")}
                            />
                        </div>
                        <div className=' col-sm-6'>
                            <input
                                type='text'
                                className='form-control'
                                placeholder='Sukunimi'
                                value={lastName}
                                onChange={e => setLastName(e.currentTarget?.value || "")}
                            />
                        </div>
                    </div>
                    <div className='row' style={{color: "black", paddingTop: 8}}>
                        <div className='col-12'>
                            <input
                                type='text'
                                className='form-control'
                                placeholder='jäsennumero'
                                defaultValue={memberId}
                                value={memberId}
                                onChange={onInputUserChange}
                            />
                        </div>
                    </div>
                    <div className='row' style={{color: "black", paddingTop: 8}}>
                        <div className='col-12'>
                            <input
                                type='text'
                                className='form-control'
                                placeholder='seura'
                                value={unknown}
                                onChange={e => setUnknown(e.currentTarget?.value || "")}
                            />
                        </div>
                    </div>
                    <div className='row' style={{color: "black", paddingTop: 8}}>
                        <div className='col-12'>
                            <input
                                type='text'
                                className='form-control'
                                placeholder='Puhelin'
                                value={phone}
                                onChange={e => setPhone(e.currentTarget?.value || "")}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        {
                            error ? (
                                <div className='col-12' style={{textAlign: "center", padding: 12}}>
                                    <span style={{color: "red"}}>{error}</span>
                                </div>
                            ) : null
                        }

                        <div className='col-12' style={{textAlign: "center", padding: 12}}>
                            <Button
                                loading={loader}
                                className='btn btn-info btn-submit'
                                disabled={member == null || loading}
                                onClick={onSubmit}
                            >
                                VAHVISTA
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
